import { createContext, FC, ReactNode, useMemo, useState } from 'react';
import {
  AdminCreditUsageContextValues,
  AdminCreditUsageTotalTable,
} from '@features/admin-credit-usage/types';
import { Option } from '@utils/react-select.ts';
import dayjs from 'dayjs';

const AdminCreditUsageContext = createContext<
  AdminCreditUsageContextValues | undefined
>(undefined);

interface AdminCreditUsageProviderProps {
  children: ReactNode;
}

const AdminCreditUsageProvider: FC<AdminCreditUsageProviderProps> = ({
  children,
}) => {
  const [selectedCreditType, setSelectedCreditType] = useState<Option>({
    value: 'all',
    label: 'All Types',
  });
  const [selectedInterval, setSelectedInterval] = useState<Option>({
    value: 'month',
    label: 'Month',
  });
  const [startDate, setStartDate] = useState<Date | null>(
    dayjs().startOf('year').toDate()
  );
  const [endDate, setEndDate] = useState<Date | null>(
    dayjs().endOf('year').toDate()
  );
  const [totalTableData, setTotalTableData] =
    useState<AdminCreditUsageTotalTable | null>(null);

  const contextValue = useMemo(
    () => ({
      selectedCreditType,
      setSelectedCreditType,
      selectedInterval,
      setSelectedInterval,
      startDate,
      setStartDate,
      endDate,
      setEndDate,
      totalTableData,
      setTotalTableData,
    }),
    [
      selectedCreditType,
      setSelectedCreditType,
      selectedInterval,
      setSelectedInterval,
      startDate,
      setStartDate,
      endDate,
      setEndDate,
      totalTableData,
      setTotalTableData,
    ]
  );

  return (
    <AdminCreditUsageContext.Provider value={contextValue}>
      {children}
    </AdminCreditUsageContext.Provider>
  );
};

export { AdminCreditUsageProvider, AdminCreditUsageContext };
